import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import PrivateNavBar from '../nav-bar/PrivateNavBar'
import PrivateFooter from '../footer/PrivateFooter'
import { Switch, Route } from 'react-router-dom'
import { List } from './List'
import Create from './Create'
import '../private-site/bootstrap.min.css'
import '../private-site/flickity.css'
import '../private-site/privateSite.css'

export class Manager extends Component {

  render() {

    return (
      <React.Fragment>
        <PrivateNavBar />
        <Switch>
          <Route path={`${this.props.match.url}/create`} component={Create} />
          <Route path="/" component={List} />
        </Switch>
        <PrivateFooter />
      </React.Fragment>
    )
  }
}


const mapStateToProps = state => {
  return {
    user: state.authUser.user
  }
}

const mapDispatchToProps = {}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Manager)))